module.exports = __webpack_public_path__ + "static/media/ipad_pro.9200e1b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple/ipad_pro.png
// module id = 1137
// module chunks = 0